// extracted by mini-css-extract-plugin
module.exports = {"footerActions":"styles_footerActions__sIl5J","footerDisclaimer":"styles_footerDisclaimer__8lr01","footer":"styles_footer__Lv03I"};